var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 9,
    viewBox: "0 0 30 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4912_59625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77787 7.96492C4.03987 7.95826 3.33408 7.64102 2.8136 7.08203C2.29311 6.52303 1.9999 5.76735 1.99756 4.9789C2.00242 4.18431 2.29887 3.42348 2.82319 2.8599C3.34752 2.29632 4.05786 1.97497 4.80158 1.96492C6.29068 1.95269 7.63996 3.39678 7.62524 4.98589C7.61297 6.62392 6.33076 7.96492 4.77787 7.96492Z",
    fill: "#4E4FA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 4.96485C27.999 5.75286 27.7084 6.50899 27.1906 7.07019C26.6728 7.63139 25.9693 7.9527 25.2317 7.96485C23.6682 7.97533 22.3631 6.60113 22.3697 4.95436C22.3778 3.38185 23.7132 1.96136 25.1827 1.96485C26.7208 1.9666 27.9998 3.33468 27.9998 4.96485Z",
    fill: "#4E4FA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2227 4.94845C12.2284 3.31653 13.4844 1.96767 15.003 1.9668C16.5321 1.9668 17.7898 3.33488 17.7833 4.98951C17.7975 5.3905 17.7356 5.79041 17.6011 6.16511C17.4667 6.53981 17.2626 6.88153 17.0012 7.16964C16.7397 7.45775 16.4264 7.68628 16.08 7.84143C15.7336 7.99658 15.3613 8.07514 14.9857 8.07237C14.6101 8.06959 14.2389 7.98554 13.8946 7.82528C13.5502 7.66502 13.2398 7.43189 12.9822 7.13994C12.7245 6.84799 12.5248 6.50329 12.3953 6.12663C12.2657 5.74998 12.2089 5.34919 12.2284 4.94845H12.2227Z",
    fill: "#4E4FA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4912_59625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 6,
    fill: "white",
    transform: "translate(2 1.96289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/action-icon.949f600c7f38000e9b5e471a64e39084.svg";
export { ForwardRef as ReactComponent };